import { render, staticRenderFns } from "./VDesignTask.vue?vue&type=template&id=341f4b9d&"
import script from "./VDesignTask.vue?vue&type=script&lang=ts&"
export * from "./VDesignTask.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignTask.vue?vue&type=style&index=0&id=341f4b9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports